const CostEnforcement = {
  NONE: "NONE",
  WARN: "WARN",
  FORCE: "FORCE",
} as const;

type CostEnforcement = (typeof CostEnforcement)[keyof typeof CostEnforcement];

export default CostEnforcement;
export type { CostEnforcement };
